import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { Suspense, lazy } from 'react';
import ErrorPage from '../modules/error/ErrorPage';

const SubCategorySection = lazy(() => import('../modules/settings/subcategories/SubCategorySection'));

const SubCategoryRoutes = (
  <>
    <Route
      path="subcategories"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <SubCategorySection />
        </Suspense>
      }
    />
  </>
);

export default SubCategoryRoutes; 